<template>
    <div class="animated fadeIn">
        <!-- <div v-if="iscreate">
      <createsubscriptionplan
        @created="iscreate = false"
      ></createsubscriptionplan>
    </div>
    <div v-if="isedit">
      <editsubscriptionplan
        @edit="isedit = false"
        :details="subscriptionplanData"
      ></editsubscriptionplan>
    </div>
    <div v-if="isview">
      <viewsubscriptionplan
        @view="isview = false"
        :details="subscriptionplanData"
      ></viewsubscriptionplan>
    </div> -->
        <b-row>
            <b-col>
                <component-header
                    title="Subscription Plan"
                    @create-press="
                        $router.push({ name: 'Create Subscriptionplan' })
                    "
                    :hasClear="false"
                    :hasReload="false"
                    @search-query="(val) => (filter = val)"
                />
            </b-col>
        </b-row>
        <b-card>
            <div class="mt-2" v-if="!iscreate && !isedit && !isview">
                <b-table
                    style="border-radius: 12px"
                    :dark="dark"
                    :hover="hover"
                    :striped="striped"
                    :bordered="bordered"
                    :small="small"
                    :filter="filter"
                    :fixed="fixed"
                    responsive
                    id="my-table"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :items="subscriptionplanList"
                    thead-class="header"
                    class="mt-3"
                    :fields="Columns"
                    show-empty
                    @filtered="onFilter"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                >
                    <template slot="cell(action)" slot-scope="data">
                        <div class="inline_btnTable">
                            <b-button
                                size="sm"
                                class="button-circle mr-2"
                                variant="primary"
                                @click="navigateTo(data.item, 'view')"
                            >
                                <i class="fa fa-eye"></i>
                            </b-button>
                            <b-button
                                size="sm"
                                class="button-circle mr-2"
                                style="background: #fe7b08; border: #fe7b08"
                                variant="primary"
                                @click="navigateTo(data.item, 'edit')"
                            >
                                <i class="fas fa-pencil-alt edit"></i>
                            </b-button>
                            <!-- <b-button
              size="sm"
              class="mr-2"
              variant="danger"
              @click="deleteSubscriptionplan(data)"
            >
              <i class="fa fa-trash bin"></i>
            </b-button> -->
                        </div>
                    </template>
                    <template v-slot:empty="scope">
                        <h4>{{ scope.emptyText }}</h4>
                    </template>
                </b-table>
            </div>
            <div
                style="float: right"
                v-if="subscriptionplanList.length > perPage"
            >
                <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="filterCount"
                    aria-controls="my-table"
                    prev-text="Prev"
                    next-text="Next"
                    hide-goto-end-buttons
                ></b-pagination>
            </div>
            <!-- <p v-else style="text-align:center;padding-top:10px;">No data available!</p> -->
        </b-card>
    </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
import Createsubscriptionplan from "@/components/MasterSetup/subscriptionplan/CreateSubscriptionplan";
import Editsubscriptionplan from "@/components/MasterSetup/subscriptionplan/EditSubscriptionplan";
import Viewsubscriptionplan from "@/components/MasterSetup/subscriptionplan/ViewSubscriptionplan";
import ComponentHeader from "@/components/componentNewHeader";
export default {
    name: "Coupondetails",
    components: {
        ebButton,
        loader,
        ComponentHeader,
        Createsubscriptionplan,
        Editsubscriptionplan,
        Viewsubscriptionplan,
    },
    data() {
        return {
            perPage: 10,
            filter: "",
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            dark: false,
            fixed: false,
            currentPage: 1,
            context: "Add",
            faqModal: false,
            header: "Edit Faq",
            filterCount: 0,
            sortBy: "createdAt",
            sortDesc: true,
            subscriptionplanData: [],
            Columns: [
                {
                    key: "applicableTo",
                    sortable: true,
                },
                {
                    key: "Plan_Name",
                },
                {
                    key: "Plan_Description",
                },
                {
                    key: "Plan_Price",
                },
                {
                    key: "action",
                },
            ],
        };
    },
    mounted() {
        this.$store.dispatch("subscriptionplan/subscriptionplanList");
    },
    computed: {
        subscriptionplanList() {
            let data =
                this.$store.getters["subscriptionplan/subscriptionplanList"];
            let subscriptionList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.map((e) => {
                    let arrayObj = {
                        applicableTo: e.scope.toUpperCase(),
                        Plan_Name: e.planName.toUpperCase(),
                        Plan_Price: e.pricing.price,
                        Plan_Description: e.planDescription,
                        ...e,
                    };
                    subscriptionList.push(arrayObj);
                });

                return subscriptionList;
            } else {
                this.loading = false;
                return [];
            }
        },
    },
    methods: {
        onFilter(list) {
            this.filterCount = list.length;
            this.currentPage = 1;
        },
        navigateTo(data, path) {
            if (path === "edit") {
                this.$router.push({
                    name: "Edit Subscriptionplan",
                    params: { data },
                });
            }
            if (path === "view") {
                this.$router.push({
                    name: "View Subscriptionplan",
                    params: { data },
                });
            }
        },

        // deleteSubscription(couponcode) {
        //   this.$swal({
        //     title: "Delete this coupon?",
        //     text: "Are you sure? You won't be able to revert this!",
        //     type: "warning",
        //     showCancelButton: true,
        //     confirmButtonColor: "#3085d6",
        //     confirmButtonText: "Yes, Delete it!"
        //   }).then(result => {
        //     if (result.value) {
        //       this.$store
        //         .dispatch("coupon/deleteCouponcode", {
        //           promoCode: couponcode.item.CouponCode
        //         })
        //         .then(result => {
        //           this.$toasted.success("coupon Deleted Successfully");
        //           this.$store
        //             .dispatch(
        //               "coupon/couponCodeList",
        //               this.$store.getters["auth/getUserID"]
        //             )
        //             .catch(error => {
        //               this.$toasted.error(error.message);
        //             });
        //         });
        //     }
        //   });
        //   this.$store.dispatch(
        //     "coupon/couponCodeList",
        //     this.$store.getters["auth/getUserID"]
        //   );
        // }
    },
    async mounted() {
        try {
            await this.$store.dispatch(
                "subscriptionplan/subscriptionplanList",
                this.$store.getters["auth/getUserID"],
            );
            this.filterCount = this.subscriptionplanList.length;
        } catch (error) {
            this.$toasted.error(error.message);
        }
    },
};
</script>
<style lang="sass" scoped>
.edit
  color: white !important
.text-center
  text-align: center
.form-div label
  margin-top: 8px
</style>
